import { useMemo } from 'react'
import { StudioRoute, useGetRoutes } from '@/lib/react-query'
import _ from 'lodash'

export const useSortedRoutes = (projectId: number): [StudioRoute[], boolean] => {
  const query = useGetRoutes(projectId)

  const routes = useMemo(() => _.orderBy(query.data, ['createdAt'], ['desc']), [query.data])

  return [routes, query.isLoading]
}
